import React from "react"
import { Link } from "gatsby"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "../CardComponent/Card.module.scss"

const HomepageBlogCard = ({ data }) => {
  const locale = process.env.language
  let readMore
  let headerImage
  let imageHeight

  if (data.articleHeaderImage) {
    headerImage = data.articleHeaderImage.file.url
    imageHeight = "h-[250px]"
  } else if (data.headerImage) {
    headerImage = data.headerImage[0].file.url
    imageHeight = "h-[250px]"
  } else {
    headerImage = ""
    imageHeight = "border border-gray-100"
  }

  // if (locale === "nl") {
  //   readMore = "Lees meer"
  // } else if (locale === "de") {
  //   readMore = "Lesen Sie mehr"
  // } else if (locale === "en" || "en-US") {
  //   readMore = "Read more"
  // } else {
  //   ;<></>
  // }
  return (
    <>
      <Link
        className={
          "flex-col w-full inline-block lg:max-w-s bg-white shadow-xl relative h-[620px] rounded-3xl [break-inside:avoid]"
        }
        to={"/" + data.slug}
      >
        <div
          className={`${imageHeight} w-full whitespace-nowrap bg-cover`}
          style={{
            backgroundImage: `url(${headerImage})`,
            borderTopLeftRadius: `20px`,
            borderTopRightRadius: `20px`,
            objectFit: `contain`,
          }}
        ></div>
        {/* <div className={"px-7 py-4 h-auto border border-[red] text-wrap"}>
          <h1 className="text-[30px]">{data.titleForOverviewPage}</h1>
          <div className={styles.textEllipsis}>
            <RenderRichContent content={data.shortIntroForOverviewPage} />
          </div> */}
        {data.titleForOverviewPage ? 
          <div className={"px-7 py-4 h-auto text-wrap"}>
          <h5 className="text-[30px] ">{data.titleForOverviewPage}</h5>
          <div className={styles.textEllipsis}>
            <RenderRichContent content={data.shortIntroForOverviewPage} />
          </div>
          </div>
          
          :
          
          <div className={"px-7 py-4 h-auto"}>
                    <h1 className="text-[30px]">{data.title}</h1>
                    <div className={styles.textEllipsis}>
                    <RenderRichContent content={data.articleShortIntro} className="text-[20px] font-[500]" />
                    </div>
                  </div>
        }
         
        {/* </div> */}
        {/* <div
          className={
            "py-2 border-b border-black mb-4 mx-4 text-edc-light-blue text-sm hover:underline"
          }
        >
          {readMore}
        </div> */}
        <img
          src="https://images.ctfassets.net/rh7phaxwpmak/P2l6voftYloczc96amt7u/a485a70a90a4837a2ff55619e74aa16b/arrow-blue-new__2_.svg"
          className={
            "absolute right-4 bottom-3 max-h-[50px] m-0 self-end my-auto"
          }
        />
      </Link>
    </>
  )
}

export default HomepageBlogCard;
